import { Space, Typography } from "antd";
import moment from "moment";
import { useIntl } from "react-intl";

type Props = {
  conduct: any;
};

export const SuspendedRosterStatusPopupConductItem = ({ conduct }: Props) => {
  const { formatMessage } = useIntl();

  const dates = [
    { labelId: "rosterStatus.suspension.dateFrom", value: conduct?.dateSuspendedFrom },
    { labelId: "rosterStatus.suspension.dateTo", value: conduct?.dateSuspendedTo },
  ];

  return (
    <Space direction="vertical" size={4}>
      {dates.map(({ labelId, value }) => (
        <Space key={labelId} size="small">
          <Typography.Text>{formatMessage({ id: labelId })}:</Typography.Text>
          <Typography.Text>
            {value ? moment(value).format("D MMMM YYYY") : formatMessage({ id: "rosterStatus.suspension.notSet" })}
          </Typography.Text>
        </Space>
      ))}
      {conduct?.conductType && (
        <Typography.Text>
          {(Array.isArray(conduct.conductType) ? conduct.conductType : [conduct.conductType])
            .map((type: string) => String(type).toUpperCase())
            .join(", ")}
        </Typography.Text>
      )}
    </Space>
  );
};
